import { Outlet } from "react-router-dom";
import { Grid, Box } from "@mui/material";

// project imports
import AuthSidePanel from "../components/AuthSidePanel";
import AuthFooter from "../components/AuthFooter";

// ==============================|| AUTHENTICATION LAYOUT ||============================== //

const AuthLayout = () => (
    <Grid container sx={{ minHeight: "100vh" }}>
        <AuthSidePanel />
        <Grid
            item
            xs={12}
            md={6}
            sx={{
                display: "flex",
                flexDirection: "column",
                bgcolor: "background.paper",
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: { xs: 3, sm: 6 },
                }}
            >
                <Outlet />
            </Box>
            <Box sx={{ p: 3 }}>
                <AuthFooter />
            </Box>
        </Grid>
    </Grid>
);

export default AuthLayout;
